// Sample destinations data used by Home and Destinations pages
export const destinations = [
  {
    id: 1,
    name: 'Paris, France',
    location: 'Europe',
    price: 950,
    baseDuration: 7,
    duration: '7 jours',
    rating: 4.8,
    image: '/img/Paris.jpg',
    description: "La ville de l'amour, célèbre pour sa culture, gastronomie et monuments.",
    highlights: [
      'Tour Eiffel & bords de Seine',
      'Musées (Louvre, Orsay)',
      'Cuisine française et marchés locaux'
    ],
    activities: [
      { id: 'paris_louvre', title: 'Visite du Louvre', durationHours: 3 },
      { id: 'paris_seine', title: 'Croisière sur la Seine', durationHours: 1.5 },
      { id: 'paris_food', title: 'Food tour et marché', durationHours: 2.5 },
      { id: 'paris_montmartre', title: 'Promenade à Montmartre', durationHours: 2 },
      { id: 'paris_catacombs', title: 'Catacombes & histoire souterraine', durationHours: 2 }
    ]
  },

  {
    id: 2,
    name: 'Tokyo, Japan',
    location: 'Asie',
    price: 1500,
    baseDuration: 7,
    duration: '7 jours',
    rating: 4.9,
    image: '/img/Tokyo.jpg',
    description: 'Une mégalopole moderne mêlée à des traditions anciennes.',
    highlights: [
      'Quartiers animés (Shinjuku, Shibuya)',
      'Temples et traditions',
      'Cuisine de rue et marchés'
    ],
    activities: [
      { id: 'tokyo_temples', title: 'Visite des temples (Asakusa, Senso-ji)', durationHours: 2 },
      { id: 'tokyo_tsukiji', title: 'Marché & dégustation (Tsukiji)', durationHours: 2 },
      { id: 'tokyo_skytree', title: 'Observation depuis la Tokyo Skytree', durationHours: 1.5 },
      { id: 'tokyo_shibuya', title: 'Traversée de Shibuya & cafés thématiques', durationHours: 1.5 },
      { id: 'tokyo_onsen', title: 'Bain relaxant / onsen urbain', durationHours: 2 }
    ]
  },

  {
    id: 3,
    name: 'Reykjavik, Iceland',
    location: 'Europe',
    price: 1200,
    baseDuration: 7,
    duration: '7 jours',
    rating: 4.7,
    image: '/img/Reykjavik.jpg',
    description: 'Paysages volcaniques, geysers et aurores boréales.',
    highlights: [
      'Sources chaudes et paysages géothermiques',
      'Observation des aurores boréales (saison)',
      'Randonnées et cascades'
    ],
    activities: [
      { id: 'reyk_geysir', title: 'Excursion au Cercle d\'Or', durationHours: 6 },
      { id: 'reyk_aurora', title: 'Sortie observation des aurores', durationHours: 3 },
      { id: 'reyk_hike', title: 'Randonnée côtière', durationHours: 4 },
      { id: 'reyk_glacier', title: 'Marche guidée sur glacier', durationHours: 5 }
    ]
  },

  {
    id: 4,
    name: 'London, England',
    location: 'Europe',
    price: 1400,
    baseDuration: 7,
    duration: '7 jours',
    rating: 4.6,
    image: '/img/London.jpg',
    description: 'Une ville riche en histoire et en culture.',
    highlights: [
      'Musées nationaux gratuits',
      'Théâtre West End',
      'Promenades le long de la Tamise'
    ],
    activities: [
      { id: 'london_britishmuseum', title: 'British Museum & galleries', durationHours: 3 },
      { id: 'london_westend', title: 'Soirée West End', durationHours: 3 },
      { id: 'london_tower', title: 'Visite Tower of London', durationHours: 2 },
      { id: 'london_camden', title: 'Balade au marché de Camden', durationHours: 2 },
      { id: 'london_eye', title: 'Balade et vue depuis le London Eye', durationHours: 1.5 }
    ]
  },

  {
    id: 5,
    name: 'Bali, Indonesia',
    location: 'Asie',
    price: 1100,
    baseDuration: 7,
    duration: '7 jours',
    rating: 4.7,
    image: '/img/Bali.jpg',
    description: 'Plages tropicales, rizières en terrasses et culture hindou balinaise.',
    highlights: [
      'Temples et cérémonies traditionnelles',
      'Rizières de Tegallalang',
      'Plages de surf et détente'
    ],
    activities: [
      { id: 'bali_surf', title: 'Cours de surf à Kuta', durationHours: 2 },
      { id: 'bali_uluwatu', title: 'Visite du temple Uluwatu et danse Kecak', durationHours: 3 },
      { id: 'bali_tegallalang', title: 'Trek dans les rizières de Tegallalang', durationHours: 2 },
      { id: 'bali_spa', title: 'Journée spa & soins balinais', durationHours: 3 },
      { id: 'bali_dive', title: 'Plongée ou snorkeling', durationHours: 2.5 }
    ]
  },

  {
    id: 6,
    name: 'New York, USA',
    location: 'Amérique',
    price: 1250,
    baseDuration: 5,
    duration: '5 jours',
    rating: 4.8,
    image: '/img/New-York.jpg',
    description: "La ville qui ne dort jamais : musées, gratte-ciels et vie culturelle intense.",
    highlights: [
      'Times Square & Broadway',
      'Central Park et musées (Met, MoMA)',
      'Quartiers variés et gastronomie internationale'
    ],
    activities: [
      { id: 'ny_moma', title: 'Visite du MoMA', durationHours: 2 },
      { id: 'ny_statue', title: 'Ferry & Statue of Liberty', durationHours: 3 },
      { id: 'ny_broadway', title: 'Spectacle Broadway', durationHours: 3 },
      { id: 'ny_centralpark', title: 'Balade à Central Park', durationHours: 2 }
    ]
  },

  {
    id: 7,
    name: 'Rio de Janeiro, Brazil',
    location: 'Amérique',
    price: 980,
    baseDuration: 6,
    duration: '6 jours',
    rating: 4.7,
    image: '/img/Rio.jpg',
    description: 'Plages emblématiques, forêts et une vie festive incomparable.',
    highlights: [
      'Copacabana & Ipanema',
      'Statue du Christ Rédempteur',
      'Randonnée dans la forêt de Tijuca'
    ],
    activities: [
      { id: 'rio_christ', title: 'Visite du Christ Rédempteur', durationHours: 2 },
      { id: 'rio_sugar', title: 'Montée au Pain de Sucre', durationHours: 2 },
      { id: 'rio_samba', title: 'Soirée samba locale', durationHours: 3 }
    ]
  },

  {
    id: 8,
    name: 'Montréal, Canada',
    location: 'Amérique',
    price: 1050,
    baseDuration: 5,
    duration: '5 jours',
    rating: 4.6,
    image: '/img/Montreal.jpg',
    description: "Ville bilingue et culturelle avec festivals, gastronomie et quartiers uniques.",
    highlights: [
      'Vieux-Montréal et le Vieux-Port',
      'Parc du Mont-Royal',
      'Scène food & festivals (jazz, Juste pour rire)'
    ],
    activities: [
      { id: 'mtl_oldport', title: 'Balade au Vieux-Port', durationHours: 2 },
      { id: 'mtl_montroyal', title: 'Ascension du Mont-Royal', durationHours: 2 },
      { id: 'mtl_museum', title: 'Visite du Musée des beaux-arts', durationHours: 2.5 },
      { id: 'mtl_food', title: 'Food tour et marché Jean-Talon', durationHours: 3 }
    ]
  },

  {
    id: 9,
    name: 'Bangkok, Thaïlande',
    location: 'Asie',
    price: 900,
    baseDuration: 5,
    duration: '5 jours',
    rating: 4.6,
    image: '/img/Bangkok.jpg',
    description: 'Capitale vibrante connue pour ses temples, marchés flottants et cuisine de rue.',
    highlights: [
      'Grand Palace et temples historiques',
      'Marchés flottants et marchés de nuit',
      'Street food et quartiers animés (Chinatown)'
    ],
    activities: [
      { id: 'bkk_grandpalace', title: 'Visite du Grand Palace', durationHours: 2.5 },
      { id: 'bkk_boattour', title: 'Tour en bateau sur les klongs', durationHours: 2 },
      { id: 'bkk_foodtour', title: 'Food tour à Chinatown', durationHours: 3 },
      { id: 'bkk_watpho', title: 'Visite du Wat Pho et massage traditionnel', durationHours: 2 }
    ]
  }
];
